import React from 'react';
import Homepage from './Homepage';

const HomepageContainer = () => {
  return <Homepage />;
};

export default HomepageContainer;
